export enum AchievementTypeEnum {
  MATCH_WON = 'match_won',
  PLAYER_BUY = 'player_buy',
  PLAYER_SELL = 'player_sell',
}
